"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BigDecimal_1 = require("./BigDecimal");

var BigDecimalNaN =
/*#__PURE__*/
function (_BigDecimal_1$BigDeci) {
  _inherits(BigDecimalNaN, _BigDecimal_1$BigDeci);

  function BigDecimalNaN() {
    _classCallCheck(this, BigDecimalNaN);

    return _possibleConstructorReturn(this, _getPrototypeOf(BigDecimalNaN).call(this));
  }

  _createClass(BigDecimalNaN, [{
    key: "add",
    value: function add(other) {
      return this;
    }
  }, {
    key: "sub",
    value: function sub(other) {
      return this;
    }
  }, {
    key: "mul",
    value: function mul(multiplicand) {
      return this;
    }
  }, {
    key: "div",
    value: function div(divisor) {
      return this;
    }
  }, {
    key: "negate",
    value: function negate() {
      return this;
    }
  }, {
    key: "isInfinity",
    value: function isInfinity() {
      return false;
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return true;
    }
  }, {
    key: "sign",
    value: function sign() {
      return NaN;
    }
  }, {
    key: "isZero",
    value: function isZero() {
      return false;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      return false;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return 0;
    }
  }, {
    key: "greaterThan",
    value: function greaterThan(other) {
      return false;
    }
  }, {
    key: "lessThan",
    value: function lessThan(other) {
      return false;
    }
  }, {
    key: "abs",
    value: function abs() {
      return this;
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'NaN';
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return NaN;
    }
  }, {
    key: "min",
    value: function min(other) {
      return this;
    }
  }, {
    key: "max",
    value: function max(other) {
      return this;
    }
  }]);

  return BigDecimalNaN;
}(BigDecimal_1.BigDecimal);

exports.BigDecimalNaN = BigDecimalNaN;